import {Component, ElementRef, Input, ViewChild} from '@angular/core';

import {SistemaService} from "../../../Servicios/Sistema.Service";

@Component(
  {
    selector: 'imagenCompleta',
    templateUrl: './ImagenCompleta.template.html',
    styleUrls: ['./ImagenCompleta.scss'],
  })

export class ImagenCompletaComponent
{
  @Input() imagen : string = '';

  @ViewChild('imagenCompleta') imagenCompleta! : ElementRef;

  public id : number = 0;

  public abiertaPrimeraVes : boolean = false;
  public abierto : boolean = false;
  public animacion : string = '';

  public cargada : boolean = false;
  public alto : boolean = false;
  public ancho : boolean = false;

  constructor(private  sistemaService : SistemaService)
  {
    this.sistemaService.numeroControl++;
    this.id = this.sistemaService.numeroControl;
  }

  ngOnInit()
  {
  }

  AbrirImagen()
  {
    this.animacion = this.sistemaService.animacionAbirModal;
    this.abierto = true;
    this.abiertaPrimeraVes = true;

    this.sistemaService.AbrirPanelInteriorFixed();
  }

  CerrarModal()
  {
    this.animacion = this.sistemaService.animacionCerrarModal;

    setTimeout(() =>
    {
      this.sistemaService.CerrarPanelInteriorFixed();
      this.abierto = false;
    }, 310);
  }

  ImagenCargada(imagen : any)
  {
    this.alto = this.imagenCompleta.nativeElement.height;
    this.ancho = this.imagenCompleta.nativeElement.width;

    setTimeout(() =>
    {
      this.cargada = true;
    }, 0);
  }

  ClickImagenContainer(evento : any)
  {
    if(!this.imagenCompleta.nativeElement.contains(evento.target))
    {
      this.CerrarModal();
    }
  }
}
